export class AutoTodoRule {
  id: number;
  intranet_id: number;
  matter_id: number;
  days_after: number;
  created_by: any;
  updated_by: any;
  created_at: any;
  updated_at: any;
  minimum_priority: number = 10;
  subject: string;
  message: string;
  document_types_str: string;
  matter_full_name: string;
  document_type_ids: Array<number> = [];
}
